// Imports

import { PortalProvider } from './contexts.jsx';
import { Portal } from 'src/modules/portal/jsx/component.jsx';


// Stateless components

export function App(props) {
    return  (
        <PortalProvider>
            <Portal />
        </PortalProvider>
    );
}
